
export default {
    props: {
        crumbData: {
            type: [Array, Object],
            required: true
        }
    },

    data() {
        return {
            crumbs: this.crumbData
        }
    },
    jsonld() {
        const items = this.crumbs.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': item.url,
                name: item.title,
            },
        }));
        return {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: items,
        };
    },
}
